import { selector } from 'recoil';
import axios from 'axios';
import _ from 'lodash';
import { authenticationAtom } from './atoms';

export const authenticationSelector = selector({
	key: 'AUTHENTICATION_SELECTOR',
	get: ({ get }) => {
		return get(authenticationAtom);
	},
	set: ({ get, set }, newValue) => {
		const atom = get(authenticationAtom);
		if (!_.isUndefined(newValue.session) && newValue.session !== atom.session) {
			axios.defaults.headers.common['Authorization'] = `Bearer ${newValue.session}`;
		}
		set(authenticationAtom, {
			...atom,
			...newValue
		});
	}
});
